import React from 'react';
import CircularPreloader from '../CircularPreloader/CircularPreloader';

const LoadingFallback: React.FC = () => {
  return (
    <CircularPreloader
      loading={true}
      spinnerSize={80}
      preloaderWrapperStyles={{ minHeight: '100vh' }}
    >
      {<div />}
    </CircularPreloader>
  );
};

export default LoadingFallback;
